<template>
    <div id="page-administrator-details">
      <administrator-form
          v-model="model"
          ref="form"
          :loading="loading"
          card-title="Update Administrator"
          disableContact
      />
  
      <div class="vx-row">
        <div class="vx-col sm:w-1/2">
          <div class="mt-8 flex flex-wrap items-center justify-start">
            <vs-button
              @click="$router.push({ name: 'content-management.administrators.list' })"
              class="my-4"
            >
              Cancel
            </vs-button>
          </div>
        </div>
        <div class="vx-col sm:w-1/2">
          <div class="mt-8 flex flex-wrap items-center justify-end">
            <vs-button
              :disabled="loading"
              @click="update"
              class="my-4"
              color="light"
            >
              Save
            </vs-button>
          </div>
        </div>
      </div>
    </div>
  </template>
  
  <script>
  
  import AdministratorForm from "@/views/pages/content-management/administrators/Form";
  import NotificationMixin from "@/components/mixins/NotificationMixin";
  import ViewModelMixin from "@/components/mixins/ViewModelMixin";
  
  export default {
    name: "AdministratorEdit",
    components: {
      AdministratorForm
    },
    mixins: [ViewModelMixin, NotificationMixin],
    data() {
      return {
        model: {},
        loading: false,
        modelEntity: this.$api.contentManagementAdministrators,
      };
    },
    methods: {
      getParams() {
        const params = {
          ...this.model
        }
  
        const references = [
          'Contact_FK',
        ]
  
        references.forEach((ref) => params[ref] = this.getReferenceId(ref))
  
        return params;
      },
      getReferenceId(fieldName) {
        if (!this.model[fieldName]) {
          return null;
        }
  
        return this.model[fieldName].id || null;
      },
      async update() {
        if (!this.$refs.form.validate()) {
          this.notifyError('Not all required fields have been provided');
          return false;
        }
  
        // this.loading = true;
        const params = this.getParams();

        if (!params.applications || !Object.keys(params.applications).length) {
          this.notifyError('Please select at least one Application');
          return false;
        }
  
        try {
          const {data} = await this.$api.contentManagementAdministrators.update(this.id, params);
          this.notifySuccess('Administrator updated');
          this.$router.back();
        } catch (e) {
          this.notifyError('Administrator failed to be updated');
          console.error(e)
        } finally {
        }
      }
    },
  };
  </script>
  
  <style scoped>
  
  </style>
  
